import React, { useEffect, useState } from 'react';
import { Button, Input, Space, Select } from 'antd';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { getQueryString } from 'utils/utils';
import { RefCode, CompanyCode, PmCode, CmCode, LecturerCode, OpCode } from 'components/TableSearchBox';
import { addNewSearch } from 'utils/utils';
import 'components/TableSearchBox/index.scss';
import { DatePicker } from 'components/atoms'
import moment, { Moment } from 'moment';
import { RangeValue } from 'rc-picker/lib/interface';
import { dateFormat } from 'utils/date-utils';

const cx = classNames.bind('./index.scss');
export interface ProjectSearchBoxProp {}

const ProjectSearchBox = ({}: ProjectSearchBoxProp): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const navigate = useNavigate();
  const location = useLocation();

  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
   * states
   * ====================================================== */
  const [searchInput, setSearchInput] = useState<string>('');
  const [searchMonth, setSearchMonth] = useState<string|undefined>(undefined);
  const [biz, setBiz] = useState<number>();
  const [searchStatus, setSearchStatus] = useState<string|undefined>(undefined);
  const [searchPm, setSearchPm] = useState<string|undefined>(undefined);
  const [searchCm, setSearchCm] = useState<string|undefined>(undefined);
  const [searchOp, setSearchOp] = useState<string|undefined>(undefined);  
  const [searchLecturer, setSearchLecturer] = useState<string|undefined>(undefined);
  const [searchPlace, setSearchPlace] = useState<string|undefined>(undefined);  

  /* ======================================================
   * events
   * ====================================================== */
  const onChange = (e) => {
    setSearchInput(e.target.value);
  };

  const onClickReset = (e) => {
    setSearchInput('');
    setSearchMonth(undefined);
    setBiz(0);
    setSearchStatus(undefined);
    setSearchOp(undefined);    
    setSearchPm(undefined);
    setSearchCm(undefined);
    setSearchLecturer(undefined);
    setSearchPlace(undefined);

    navigate(location.pathname);
  };

  const onSearch = (data: any) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, data),
    });    
  };

  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    const historySearch = getQueryString(location.search);
    (historySearch.search)?setSearchInput(historySearch.search):setSearchInput('');
    if (historySearch.searchDateStart) setSearchMonth(historySearch.searchDateStart);
    if (historySearch.biz) setBiz(historySearch.biz);    
    if (historySearch.status) setSearchStatus(historySearch.status);
    if (historySearch.op) setSearchOp(historySearch.op);
    if (historySearch.pm) setSearchPm(historySearch.pm);
    if (historySearch.cm) setSearchCm(historySearch.cm);
    if (historySearch.place) setSearchPlace(historySearch.place);
    setSearchLecturer(historySearch.lecturer)
  }, [location.search]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={cx('tableSearchBoxWrapper')}>
      <Space direction='vertical'>
        <Space>
          <DatePicker value={searchMonth?moment(searchMonth):undefined} format="YYYY-MM" picker="month" onChange={(value)=>!!value && onSearch({ searchDateStart: moment(value).format("YYYY-MM-DD")})}/>   
          <CompanyCode codeValue={biz} onChangeSelect={(value)=>onSearch({ biz: value, pageNo: 1 })} />
          <OpCode codeValue={(searchOp && searchOp !== 'A')?Number(searchOp):undefined} onChangeSelect={(value)=>onSearch({ op: value, pageNo: 1 })} />          
          <LecturerCode codeValue={(searchLecturer && searchLecturer !== 'A')?searchLecturer:undefined} onChangeSelect={(value)=>onSearch({ lecturer: value, pageNo: 1 })} />
          <PmCode codeValue={(searchPm && searchPm !== 'A')?Number(searchPm):undefined} onChangeSelect={(value)=>onSearch({ pm: value, pageNo: 1 })} />          
          <CmCode codeValue={(searchCm && searchCm !== 'A')?Number(searchCm):undefined} onChangeSelect={(value)=>onSearch({ cm: value, pageNo: 1 })} />  
        </Space>
        <Space>
          <Select 
            value={searchPlace}
            onSelect={(value)=>{onSearch({ place: value, pageNo: 1 })}}
            options={[
              {label:'전체', value: 'A'},
              {label:'오프라인', value: '오프라인'},
              {label:'온라인', value: '온라인'},              
            ]}
            placeholder="교육장소"            
            style={{width: '100px'}}
          />          
          <RefCode codeValue={searchStatus} fieldName={'project_status_type'} placeholder={'프로젝트상태'} onChangeSelect={(value)=>onSearch({ status: value, pageNo: 1 })} />
          <Input.Search
            className={cx('searchInput')}
            value={searchInput}
            placeholder="프로젝트명을 입력하세요"
            onChange={onChange}
            onSearch={(value)=>onSearch({ search: value, pageNo: 1 })}
            allowClear
          />
          <Button onClick={onClickReset}>
            검색초기화
          </Button>                
        </Space>      
      </Space>
    </div>
  );
};

export default ProjectSearchBox;
